if($('.container.project').length){
  var rate = $('.container.project').attr('data-rate');
  var duration = $('.container.project').attr('data-duration');;
  var schedule = $('.container.project').attr('data-schedule');;
  var delay = $('.container.project').attr('data-delay');;
  var locale = $('body').attr('data-wp-locale');

  var truncate = function(number, places) {
    places = places || 2;
    var numPower = Math.pow(10, places);
    return ~~(number * numPower) / numPower;
  };
  var paybacks = function(rate, investment, duration, schedule, scheduleDelay) {
    var monthlyRate = (rate * 0.01) / (365 / 30);
    var monthlyPayback;

    if (schedule === 'bullet') {
      monthlyPayback = investment * monthlyRate;
      return {
        monthly: truncate(monthlyPayback, 2),
        total: truncate(+investment + monthlyPayback * duration, 2)
      };
    }

    else if (schedule === 'full-bullet') {
      return {
        monthly: 0,
        total: truncate(+investment + (investment * monthlyRate * duration), 2)
      };
    }

    else if (schedule === 'delayed') {
      var interests = truncate(investment * monthlyRate, 2);
      monthlyPayback = investment * (monthlyRate / (1 - Math.pow(1 + monthlyRate, -(duration - scheduleDelay))));

      return {
        interests: interests,
        monthly: truncate(monthlyPayback, 2),
        firstMonthly: scheduleDelay + 1,
        total: truncate(monthlyPayback * (duration - scheduleDelay) + interests * scheduleDelay, 2)
      };
    }

    else {
      monthlyPayback = investment * (monthlyRate / (1 - Math.pow(1 + monthlyRate, -duration)));
      return {
        monthly: truncate(monthlyPayback, 2),
        total: truncate(monthlyPayback * duration, 2)
      };
    }
  };


  function updateValues() {
    var amountInput = $('input[type=range]').val();

    var p = paybacks(rate, amountInput, duration, schedule, delay);

    $('span.amount.input').text(currencyFormatI18n(amountInput, 0, locale));
    $('span.amount.output').text(currencyFormatI18n(p.total, 2, locale));
    var val = ($('input[type=range]').val() - $('input[type=range]').attr('min')) / ($('input[type=range]').attr('max') - $('input[type=range]').attr('min'));
    $('input[type=range]').css('background-image',
      '-webkit-gradient(linear, left top, right top, '
      + 'color-stop(' + val + ', #1328A1), '
      + 'color-stop(' + val + ', #F2F2F5)'
      + ')'
      );
  }

  $('input[type=range]').on('change mousemove', function() {
    updateValues();
  });

  $(function(){
    updateValues();
  })
}
